import React from 'react'
import { FormattedNumber } from 'react-intl'
import { colors, Text } from 'ic-snacks'

const POLYGON_POINTS = {
  positive: 'M 5,1 0,10 10,10 z',
  negative: 'M 0,0 5,9 10,0 z',
  neutral: 'M 0,0 z',
}

const COLORS = {
  positive: colors.GREEN_500,
  negative: colors.RED_500,
  neutral: colors.GRAY_46,
}

interface Props {
  value: number | null
  previousValue: number | null
  desiredDirection: 'positive' | 'negative' | 'neutral'
}

class Delta extends React.PureComponent<Props> {
  static defaultProps = {
    desiredDirection: 'positive',
  }

  calculateDeltaAsPercentage = (current: number | null, previous: number | null) => {
    if (current === null || previous === null) return 0

    if (current === 0 && previous === 0) return 0
    if (previous === 0 && current !== 0) return 0

    return (current - previous) / previous
  }

  render() {
    const { value, previousValue, desiredDirection } = this.props
    const delta = this.calculateDeltaAsPercentage(value, previousValue)

    const deltaDirection = delta > 0 ? 'positive' : delta < 0 ? 'negative' : 'neutral'
    const colorDirection =
      (deltaDirection === 'positive' && desiredDirection === 'positive') ||
      (deltaDirection === 'negative' && desiredDirection === 'negative')
        ? 'positive'
        : deltaDirection === 'neutral'
        ? 'neutral'
        : 'negative'

    return (
      <span style={{ display: 'flex', alignItems: 'center' }}>
        {deltaDirection !== 'neutral' && (
          <svg
            height="10px"
            width="10px"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: '0 5px' }}
          >
            <path d={POLYGON_POINTS[deltaDirection]} fill={COLORS[colorDirection]} />
          </svg>
        )}
        <Text
          variant="T.18"
          elementType="span"
          style={{ color: COLORS[colorDirection] || colors.GRAY_46 }}
        >
          {delta === 0 ? (
            '—'
          ) : (
            <FormattedNumber
              // eslint-disable-next-line react/style-prop-object
              style="percent"
              minimumFractionDigits={1}
              value={delta}
            />
          )}
        </Text>
      </span>
    )
  }
}

export default Delta
